export const state = () => ({
  expertDetailName: ''
})

export const mutations = {
  SET_EXPERTDETAILNAME: function(state, payload) {
    state.expertDetailName = payload
  }
}
